:host {
  display: block;

  a {
    display: block;
    text-decoration: none;
    height: 100%;
  }
}
